<template>
  <div id="info">
    <div class="info_wrap">
      <loading v-if="isShowLoading"></loading>
      <div class="title">
        <img src="../../assets/zixun.png" alt="新鲜资讯" />
      </div>
      <div class="dsj"></div>
      <template v-if="!infoList.length">
        <div class="contentList">
          <dl>
            <dt style="background-color: #ececec;"></dt>
            <dd>
              <h3></h3>
              <p>暂无资讯信息</p>
            </dd>
          </dl>
        </div>
      </template>
      <template v-else>
        <div class="contentList">
          <dl v-for="(item,idx) in infoList" :key="item.amid" v-show="item.byisuse!=0">
            <dt>
              <img :src="item.amtopics" alt="" @click="gotoDetail(item.amid)" />
            </dt>
            <dd>
              <h3 @click="gotoDetail(item.amid)">{{ item.amtopicf }}</h3>
              <h4>{{ item.dtmakedate.split(' ')[0] }}&nbsp;&nbsp;&nbsp;发布</h4>
              <p @click="gotoDetail(item.amid)"> {{ item.amdesc }}</p>
            </dd>
          </dl>
        </div>
      </template>
      <div class="fenye">
        <Page v-if="pageObj.total > 0" :total="pageObj.total" :current="pageObj.page" prev-text="上一页" next-text="下一页"
          @on-change="changePage">
        </Page>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "freshInformation",
    data: function () {
      return {
        isShowLoading: false,
        infoList: [],
        pageObj: {
          total: 0,
          pageNum: 10,
          page: 1
        }
      }
    },
    async created() {
      this.getInformation()
    },
    methods: {
      //获取文章资讯列表
      async getInformation() {
        this.isShowLoading = true
        this.$store.commit('setMenuIndex', '4');
        const res = await this.$api.get2(this.lee + '/ec/home/v1/getHomeStrategy', {
          url: window.location.hostname,
          page: this.pageObj.page,
          pageSize: this.pageObj.pageNum
        });
        this.isShowLoading = false
        if (!res) return false
        this.infoList = res.data.information.items;
        this.total = res.data.information.totalCount;
      },
      //点击跳转详情
      gotoDetail(amid) {
        this.$store.commit('setMenuIndex', '4');
        this.$router.push({
          name: 'articleDetail',
          params: {
            aId: amid,
            part: '新鲜资讯',
            partName: 'information'
          }
        });
      },
      async changePage(num) {
        this.pageObj.page = num;
        this.getInformation()
        window.scrollTo(0, 0);
      }
    }
  }
</script>

<style lang="less">
  #info {
    padding: 48px 0 101px;
    background-color: #fff;

    .info_wrap {
      width: 1200px;
      margin: 0 auto;

      .contentList {
        overflow: hidden;
        margin-bottom: 68px;

        dl {
          overflow: hidden;
          margin-bottom: 33px;

          dt {
            width: 200px;
            height: 166px;
            border: 1px solid #ececec;
            padding: 2px;
            background-color: #fff;
            float: left;
            margin-right: 40px;

            img {
              width: 194px;
              height: 160px;
              cursor: pointer;
            }
          }

          dd {
            float: left;
            width: 960px;
            height: 166px;

            h3 {
              font-size: 16px;
              color: #191919;
              height: 24px;
              line-height: 24px;
              margin-bottom: 8px;
              cursor: pointer;
            }

            h4 {
              font-size: 12px;
              color: #afb0b3;
              margin-bottom: 16px;
              font-weight: normal;
            }

            p {
              font-size: 14px;
              color: #5e5e60;
              line-height: 20px;
              // text-indent: 2em;
              cursor: pointer;
            }
          }
        }
      }

      .fenye {
        text-align: center;

        .ivu-page {

          &-item,
          &-prev,
          &-next {
            min-width: 24px;
            height: 24px;
            line-height: 24px;
            border-radius: 0;

            a {
              position: relative;
              top: -1px;
              margin: 0 6px;
            }
          }

          &-prev,
          &-next {
            border: 1px solid #dcdee2;
            padding: 0 2px;

            &:hover {
              border-color: #4e81f0;

              a {
                color: #4e81f0;
              }
            }
          }

          &-item {
            &:hover {
              border-color: #4e81f0;

              a {
                color: #4e81f0;
              }
            }

            &-active {
              background-color: #4e81f0;
              border-color: #4e81f0;

              a {
                color: #ffffff;
              }

              &:hover {
                border-color: #4e81f0;

                a {
                  color: #ffffff;
                }
              }
            }

            &-jump-prev,
            &-jump-next {
              &:hover {
                a {
                  color: #4e81f0;
                }
              }
            }
          }

          &-disabled {
            &:hover {
              border-color: #dcdee2;

              a {
                color: #ccc;
              }
            }
          }
        }
      }

      // 图片标题
      .title {
        text-align: center;
        height: 90px;
        padding-bottom: 10px;
        margin-bottom: 8px;
        border-bottom: 1px solid #ececec;

        img {
          height: 86px;
        }
      }

      // 倒三角符号
      .dsj {
        width: 0px;
        height: 0px;
        margin: 0 auto 40px;
        border: 8px solid #4b7ff0;
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-right-color: transparent;
      }
    }
  }
</style>